import { render, staticRenderFns } from "./AddNewAuthenticationObjectPopup.vue?vue&type=template&id=5373f942&scoped=true"
import script from "./AddNewAuthenticationObjectPopup.vue?vue&type=script&lang=js"
export * from "./AddNewAuthenticationObjectPopup.vue?vue&type=script&lang=js"
import style0 from "./AddNewAuthenticationObjectPopup.vue?vue&type=style&index=0&id=5373f942&prod&lang=scss&scoped=true"
import style1 from "./AddNewAuthenticationObjectPopup.vue?vue&type=style&index=1&id=5373f942&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5373f942",
  null
  
)

export default component.exports